import styles from "./Cart.module.scss";
import { Button, Loader, Text } from "@eventsquare/uikit";
import { useAppContext } from "@context/appContext";
import { CartItem as CartItemType } from "@type/carts";
import { Product } from "@type/products";
import CartItem from "../CartItem/CartItem";
import { RiDeleteBinLine } from "@remixicon/react";
import { useState } from "react";
import ClearModal from "@components/ClearModal/ClearModal";

const Cart = () => {
  const { cart, products } = useAppContext();
  const [showClearModal, setShowClearModal] = useState(false);

  const getProductDetails = (uid: string): Product | undefined =>
    products?.find((product) => product.uid === uid);

  const isCartEmpty = (cartItems: CartItemType[]): boolean =>
    cartItems.length === 0;

  if (!cart || !products) {
    return (
      <div className={styles.cart}>
        <div className={styles.cart__loader}>
          <Loader size="medium" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.cart}>
        <div className={styles.cartHeader}>
          <Text variant="h3" noMargin>
            Basket
          </Text>
          <Button
            color="error"
            variant="outline"
            size="small"
            onClick={() => setShowClearModal(true)}
            disabled={isCartEmpty(cart)}
          >
            <RiDeleteBinLine />
            Clear
          </Button>
        </div>

        <div className={styles.cartMain}>
          {isCartEmpty(cart) ? (
            <Text variant="p">No items in cart</Text>
          ) : (
            <ul className={styles.cart__list}>
              {cart.map((item: CartItemType, index: number) => (
                <CartItem
                  key={`${index}_${item.uid}`}
                  item={item}
                  index={index}
                  product={getProductDetails(item.uid)}
                />
              ))}
            </ul>
          )}
        </div>
      </div>
      <ClearModal showModal={showClearModal} setShowModal={setShowClearModal} />
    </>
  );
};

export default Cart;
